// import React, { useEffect } from "react";
// import Home_slider1_container from "./Home_slider1_container";
// import Interest_container from "./Interest_container";
// import About_virtuos from "./About_virtuos";
// import Four_blocks_container from "./Four_blocks_container";
// import Dt_container from "./Dt_container";
// import Full_height_video from "./Full_height_video";
// import Capabilities_section from "./Capabilities_section";
// import Filter_container from "./Filter_container";
// import Showcase_news_cards_wrapper from "./Showcase_news_cards_wrapper";
// import Clients_list from "./Clients_list";
// import Twittie from "./Twittie";
// import Cx_extra_features_offices_region from "./Cx_extra_features_offices_region";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import Nav from "./Nav";
// import Sidebar from "../pages/Sidebar/Sidebar";
// import NewsTwitter from "./NewsTwitter";

// const Main = () => {
//   useEffect(() => {
//     document.title =
//       "Virtuos | High performance Digital Transformation Consulting Services";
//   }, []);
//   return (
//     <div className="home-page">
//       <div className="canvas">
//         <Navbar />
//         <main className="main-wrapper">
//           <Home_slider1_container />
//           {/* <NewsTwitter/> */}
//           <Interest_container />
//           <About_virtuos />
//           <Four_blocks_container />
//           <Dt_container />
//           <Full_height_video />
//           <Capabilities_section />
//           <Filter_container />
//           <Showcase_news_cards_wrapper />
//           <Clients_list />
//           <Twittie />
//           <Cx_extra_features_offices_region />
//           <Footer />
//         </main>
//       </div>
//       <div className="off-canvas">
//         <Sidebar />
//       </div>
//     </div>
//   );
// };

// export default Main;

import React, { useEffect, Suspense } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Sidebar from "../pages/Sidebar/Sidebar";
import Chatbot from "./Chatbot";
import NewHomeBanner from "./NewHomeBanner";
const LazyHomeSlider1Container = React.lazy(() =>
  import("./Home_slider1_container")
);
const LazyInterestContainer = React.lazy(() => import("./Interest_container"));
const LazyAboutVirtuos = React.lazy(() => import("./About_virtuos"));
const LazyFourBlocksContainer = React.lazy(() =>
  import("./Four_blocks_container")
);
const LazyDtContainer = React.lazy(() => import("./Dt_container"));
const LazyFullHeightVideo = React.lazy(() => import("./Full_height_video"));
const LazyCapabilitiesSection = React.lazy(() =>
  import("./Capabilities_section")
);
const LazyFilterContainer = React.lazy(() => import("./Filter_container"));
const LazyShowcaseNewsCardsWrapper = React.lazy(() =>
  import("./Showcase_news_cards_wrapper")
);
const LazyClientsList = React.lazy(() => import("./Clients_list"));
const LazyTwittie = React.lazy(() => import("./Twittie"));
const LazyCxExtraFeaturesOfficesRegion = React.lazy(() =>
  import("./Cx_extra_features_offices_region")
);

const Main = () => {
  useEffect(() => {
    document.title =
      "Virtuos | High performance Digital Transformation Consulting Services";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Virtuos is a leading Digital Transformation Company providing strategy, consulting, and technology engineering services for CRM, Customer Experience (CX), and Employee Experience (EX)"
      );
    }
  }, []);

  return (
    <div className="home-page">
      {/* <Chatbot /> */}

      <div className="canvas">
        <Navbar />
        <main className="main-wrapper">
          {/* <Suspense fallback={<div> Loading...</div>}> */}
          <NewHomeBanner/>
            {/* <LazyHomeSlider1Container /> */}
            <LazyInterestContainer />
            <LazyAboutVirtuos />
            <LazyFourBlocksContainer />
            <LazyDtContainer />
            <LazyFullHeightVideo />
            <LazyCapabilitiesSection />
            <LazyFilterContainer />
            <LazyShowcaseNewsCardsWrapper />
            <LazyClientsList />
            <LazyTwittie />
            <LazyCxExtraFeaturesOfficesRegion />
            <Footer />
          {/* </Suspense> */}
        </main>
      </div>
      <div className="off-canvas">
        <Sidebar />
      </div>
    </div>
  );
};

export default Main;
